import { Link } from '@sparemin/blockhead'
import cn from 'classnames'
import React from 'react'
import FontAwesome from 'components/FontAwesome';
import { LEARN_CENTER_CAPTIONS } from 'utils/constants'

import { block } from './utils';

interface CaptionsLearnCenterLinkProps {
  className? : string
}

const CaptionsLearnCenterLink: React.FunctionComponent<CaptionsLearnCenterLinkProps> = (props) => {
  const { className } = props;

  return (
    <Link className={cn(block(),className)} href={LEARN_CENTER_CAPTIONS} rel="noreferrer noopener" target="_blank">
     <FontAwesome icon="info-circle" />
    </Link>
  )
}

export default CaptionsLearnCenterLink